import { AxiosInstance } from "axios";
import type {
  PlannerBucket,
  PlannerPlan,
} from "./PlannerSourceSettings.types";

export class PlannerSourceSettingsApi {
  constructor(private readonly client: AxiosInstance) {}

  async getPlans(boardId: string, connectionId: string): Promise<PlannerPlan[]> {
    const response = await this.client.get<PlannerPlan[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/microsoftplanner/plans`,
    );

    return response.data;
  }

  async getPlanBuckets(
    boardId: string,
    connectionId: string,
    planId: string,
  ): Promise<PlannerBucket[]> {
    const response = await this.client.get<PlannerBucket[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/microsoftplanner/plans/${encodeURIComponent(planId)}/buckets`,
    );

    return response.data;
  }
}